import { render } from "./ViewClient.vue?vue&type=template&id=a1d83f9e&scoped=true&ts=true"
import script from "./ViewClient.vue?vue&type=script&lang=ts"
export * from "./ViewClient.vue?vue&type=script&lang=ts"

import "./ViewClient.vue?vue&type=style&index=0&id=a1d83f9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d83f9e"]])

export default __exports__